import React from "react";

import ReadyOrdersTable from "./ReadyOrdersTable";

import { SearchTextField } from "../../../components/TextField";
import { searchBarChanged } from "../../../redux/General/clientSideSearchActionCreators";
import { Fade, Grid, Typography } from "@material-ui/core";

import Store from "../../../redux/Store";
import { connect } from "react-redux";
import { useStyles } from "../../../styles/mainStyles";

const ReacyOrders = () => {
  const searchChangeHandler = (value, action) => {
    Store.dispatch(action(value));
  };
  let border = useStyles();
  return (
    <Fade in={true} timeout={500}>
      <Grid container justifyContent="center" style={{ height: "100%" }}>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          style={{
            backgroundColor: "white",
            boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
            borderRadius: "3px",
            height: "100%",
          }}
        >
          <Grid item xs={12} style={{ height: "1%" }}>
            <Typography variant="body1">سفارش ها</Typography>
          </Grid>

          <Grid
            item
            xs={12}
            container
            style={{ height: "90%", margin: 8 }}
            className={border.border}
          >
            <Grid
              container
              item
              xs={12}
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              style={{ height: 50 }}
            >
              <Grid item sm={9} xs={12}>
                <SearchTextField
                  changeHandler={searchChangeHandler}
                  action={searchBarChanged}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ height: "calc(100% - 50px)" }}>
              <ReadyOrdersTable />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};
const mapStateToProps = (props) => {
  return {};
};

export default connect(mapStateToProps)(ReacyOrders);
